"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[2027,9831],{

/***/ 6061:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Cover": function() { return /* binding */ Cover; },
/* harmony export */   "default": function() { return /* binding */ NewCover; },
/* harmony export */   "templateItemSchema": function() { return /* binding */ templateItemSchema; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__(7568);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(6042);
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_23__ = __webpack_require__(7582);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(5893);
/* harmony import */ var _comps_bubble__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(5232);
/* harmony import */ var _comps_button__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(5896);
/* harmony import */ var _comps_editors_text_to_image__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(3569);
/* harmony import */ var _comps_image__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(9612);
/* harmony import */ var _utils_branch__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(2404);
/* harmony import */ var _utils_breakpoints__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(1156);
/* harmony import */ var _utils_cdn__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(177);
/* harmony import */ var _utils_client_auth__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(1816);
/* harmony import */ var clsx__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(6010);
/* harmony import */ var next_i18next__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(2213);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(1664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(1163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_11__);
/* harmony import */ var pages_models__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(1087);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(7294);
/* harmony import */ var sections_editor_editor__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(5091);
/* harmony import */ var sections_gallery_gallery_popup__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(7276);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(9521);
/* harmony import */ var zod__WEBPACK_IMPORTED_MODULE_24__ = __webpack_require__(1604);
/* harmony import */ var _platforms_runner__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(4593);
/* harmony import */ var _qr__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(5404);




function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n	&:hover {\n		background: linear-gradient(\n			60deg,\n			rgba(134, 54, 248, 1),\n			rgba(240, 32, 179, 1),\n			rgba(248, 71, 94, 1),\n			rgba(255, 148, 33, 1)\n		);\n	}\n\n	transition-property: all;\n	transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);\n	transition-duration: 150ms;\n\n	background: linear-gradient(\n		60deg,\n		var(--color-separator),\n		var(--color-separator)\n	);\n	padding: 1.5px;\n	border-radius: 8px;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  0% {\n    transform: translateY(0);\n  }\n  100% {\n    transform: translateY(-",
        "px);\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n					animation: ",
        "\n						",
        "s linear -0s infinite\n						normal forwards;\n\n					@media ",
        " {\n						animation: ",
        "\n							",
        "s linear -0s\n							infinite normal forwards;\n					}\n\n					@media ",
        " {\n						animation: ",
        "\n							",
        "s\n							linear -0s infinite normal forwards;\n					}\n			  "
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n					animation-play-state: paused;\n			  "
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n	display: flex;\n	flex-direction: column;\n	align-items: center;\n	gap: 12px;\n	@media ",
        " {\n		gap: 16px;\n	}\n\n	",
        "\n\n	&:hover {\n		animation-play-state: paused;\n	}\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}





















var StyledPlatformContainer = styled_components__WEBPACK_IMPORTED_MODULE_18__/* ["default"].a.withConfig */ .ZP.a.withConfig({
    componentId: "sc-6b3067e8-0"
})(_templateObject());
function NewCover(props) {
    var columns = props.columns;
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_13__.useState)(null), galleryPopupState = ref[0], setGalleryPopupState = ref[1];
    (0,react__WEBPACK_IMPORTED_MODULE_13__.useEffect)(function() {
        if (galleryPopupState !== null) {
            document.body.style.overflow = "hidden";
        } else {
            document.body.style.overflow = "unset";
        }
    }, [
        galleryPopupState
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
        className: "my-[26px] flex h-full w-full flex-col items-center gap-[42px] tablet:my-[50px]",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                className: " relative flex w-full flex-col items-center px-[16px]",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                        className: "z-10 flex flex-col items-center px-[16px] desktop:px-[69px]",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_comps_bubble__WEBPACK_IMPORTED_MODULE_2__/* .NewBubble */ .jm, {
                                text: "#1 Ai Video Maker",
                                uppercase: true,
                                wideLetter: true,
                                shaddow: true
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                                className: "mt-6 flex flex-row flex-wrap items-center justify-center",
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("span", {
                                        className: "text-[24px] font-800 text-blue-900 desktop:text-[40px]",
                                        children: "AI-Powered Videos"
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("span", {
                                        dangerouslySetInnerHTML: {
                                            __html: "&nbsp;&nbsp;"
                                        }
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("video", {
                                        autoPlay: true,
                                        loop: true,
                                        muted: true,
                                        playsInline: true,
                                        src: (0,_utils_cdn__WEBPACK_IMPORTED_MODULE_19__/* .assetUrl */ .p)("/home/home_small.mp4"),
                                        className: "pointer-events-none h-[38px] w-[68px] select-none rounded-[10px] object-cover desktop:h-[54px] desktop:w-[87px]"
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("span", {
                                        dangerouslySetInnerHTML: {
                                            __html: "&nbsp;&nbsp;"
                                        }
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_comps_bubble__WEBPACK_IMPORTED_MODULE_2__/* .GradientText */ .t1, {
                                        text: "with no limits,",
                                        className: "select-none text-[24px] font-800 desktop:text-[40px]"
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("span", {
                                        dangerouslySetInnerHTML: {
                                            __html: "&nbsp;"
                                        }
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("span", {
                                        className: "text-[24px] font-800 text-blue-900 desktop:text-[40px]",
                                        children: "Just Creativity"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("h3", {
                                className: "mt-2 text-[18px] font-400 text-blue-800 desktop:text-[22px]",
                                children: "From zero to video hero, thanks to AI"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_comps_button__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP, {
                        href: "/login",
                        text: "Get started for free",
                        className: "mt-10 flex h-[56px] !w-[256px] !max-w-none items-center justify-center rounded-lg",
                        primary: true
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                        className: "z-10 mt-10 flex flex-row gap-9",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_comps_image__WEBPACK_IMPORTED_MODULE_5__/* .CustomThemedResource */ .aK, {
                                source: "/home/best-of-platform",
                                format: "svg",
                                alt: "ratings icon",
                                className: " w-[146px] tablet:w-[180px]"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_comps_image__WEBPACK_IMPORTED_MODULE_5__/* .CustomThemedResource */ .aK, {
                                source: "/home/best-for-downloads",
                                format: "svg",
                                alt: "downloads icon",
                                className: " w-[146px] tablet:w-[180px]"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                        className: "relative z-10 mt-11 flex items-center gap-[9.5px] tablet:gap-[13.5px]",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(StyledPlatformContainer, {
                                href: "/login",
                                target: "_blank",
                                rel: "noopener noreferrer",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                                    className: "rounded-[7px] bg-color-cell",
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_comps_image__WEBPACK_IMPORTED_MODULE_5__/* .CustomThemedResource */ .aK, {
                                        source: "/home/web",
                                        format: "svg",
                                        className: "h-[31px] rounded-[7px] bg-color-cell tablet:h-[45px]"
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                                className: (0,clsx__WEBPACK_IMPORTED_MODULE_20__/* ["default"] */ .Z)("group relative flex items-center gap-[9.5px] tablet:gap-[13.5px]"),
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(StyledPlatformContainer, {
                                        href: _utils_branch__WEBPACK_IMPORTED_MODULE_6__/* .appStoreConstant */ .HY,
                                        target: "_blank",
                                        rel: "noopener noreferrer",
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                                            className: "rounded-[7px] bg-color-cell hover:bg-color-cell",
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_comps_image__WEBPACK_IMPORTED_MODULE_5__/* .CustomThemedResource */ .aK, {
                                                source: "/home/app-store",
                                                format: "svg",
                                                className: "h-[31px] tablet:h-[45px]"
                                            })
                                        })
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                                        className: (0,clsx__WEBPACK_IMPORTED_MODULE_20__/* ["default"] */ .Z)("absolute left-1/2 z-50 w-[134px] -translate-x-1/2 border border-color-separator bg-color-surface-cell p-[6px] group-hover:opacity-100", "-translate-y-2 rounded-[10px] opacity-0 transition-all duration-500 group-hover:translate-y-4", "pointer-events-none top-full hidden group-hover:pointer-events-auto tablet:block desktop:block"),
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_comps_image__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .ZP, {
                                            src: (0,_utils_cdn__WEBPACK_IMPORTED_MODULE_19__/* .assetUrl */ .p)("/home/qrcode.webp"),
                                            width: 360,
                                            height: 360
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                                className: (0,clsx__WEBPACK_IMPORTED_MODULE_20__/* ["default"] */ .Z)("group relative flex items-center gap-[9.5px] tablet:gap-[13.5px]"),
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(StyledPlatformContainer, {
                                        href: _utils_branch__WEBPACK_IMPORTED_MODULE_6__/* .playStoreConstant */ .H2,
                                        target: "_blank",
                                        rel: "noopener noreferrer",
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                                            className: "rounded-[7px] bg-color-cell hover:bg-color-cell",
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_comps_image__WEBPACK_IMPORTED_MODULE_5__/* .CustomThemedResource */ .aK, {
                                                source: "/home/android",
                                                format: "svg",
                                                className: "h-[31px] tablet:h-[45px]"
                                            })
                                        })
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                                        className: (0,clsx__WEBPACK_IMPORTED_MODULE_20__/* ["default"] */ .Z)("absolute left-1/2 z-50 w-[134px] -translate-x-1/2 border border-color-separator bg-color-surface-cell p-[6px] group-hover:opacity-100", "-translate-y-2 rounded-[10px] opacity-0 transition-all duration-500 group-hover:translate-y-4", "pointer-events-none top-full hidden group-hover:pointer-events-auto tablet:block desktop:block"),
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_comps_image__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .ZP, {
                                            src: (0,_utils_cdn__WEBPACK_IMPORTED_MODULE_19__/* .assetUrl */ .p)("/home/qrcode.webp"),
                                            width: 360,
                                            height: 360
                                        })
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                        className: "relative flex w-screen items-center justify-center",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                                className: "pointer-events-none absolute -top-[15%] left-0 w-full select-none overflow-x-clip tablet:-top-[40%] desktop:-top-[60%]",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_comps_image__WEBPACK_IMPORTED_MODULE_5__/* .CustomThemedResource */ .aK, {
                                    source: "/home/cover-new",
                                    alt: "cover background image",
                                    format: "webp",
                                    className: "h-[300px] w-full scale-[2.5] object-contain opacity-80 tablet:h-[500px] tablet:scale-150 desktop:h-[900px] desktop:scale-150 desktop:opacity-50 desktop:backdrop-blur-3xl"
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(GridColumns, {
                                setGalleryPopupState: setGalleryPopupState,
                                columns: columns,
                                shouldPlay: !Boolean(galleryPopupState)
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                className: "flex w-full justify-center px-[16px]",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_comps_button__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP, {
                    text: "Discover templates",
                    href: "/video-templates",
                    primary: true,
                    className: "flex h-[56px] !w-[256px] !max-w-none items-center justify-center rounded-lg !p-0"
                })
            }),
            galleryPopupState !== null && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(sections_gallery_gallery_popup__WEBPACK_IMPORTED_MODULE_15__/* .GalleryPopup */ .wY, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_21__/* ["default"] */ .Z)({}, galleryPopupState))
        ]
    });
}
function Cover(props) {
    var columns = props.columns;
    var t = (0,next_i18next__WEBPACK_IMPORTED_MODULE_9__/* .useTranslation */ .$G)("common").t;
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_13__.useState)(null), galleryPopupState = ref[0], setGalleryPopupState = ref[1];
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_11__.useRouter)();
    (0,react__WEBPACK_IMPORTED_MODULE_13__.useEffect)(function() {
        if (galleryPopupState !== null) {
            document.body.style.overflow = "hidden";
        } else {
            document.body.style.overflow = "unset";
        }
    }, [
        galleryPopupState
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
        className: "flex h-full w-full flex-col items-center gap-[42px]",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                className: "relative flex h-[930px] w-full bg-[inherit] px-[16px] tablet:h-[900px] desktop:h-[1050px]",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                        className: (0,clsx__WEBPACK_IMPORTED_MODULE_20__/* ["default"] */ .Z)(pages_models__WEBPACK_IMPORTED_MODULE_12__.backgroundGradient, "absolute left-0 top-0 z-0 h-[462px] w-full rounded-b-[16px] tablet:h-[531px] desktop:h-[736px]")
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                        className: "absolute left-0 z-10 flex w-full flex-col items-center",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                                className: "flex flex-col items-center gap-[22px] px-[16px] pt-[26px] tablet:pt-[50px] desktop:px-[69px]",
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("h1", {
                                        className: (0,clsx__WEBPACK_IMPORTED_MODULE_20__/* ["default"] */ .Z)("rounded-[38px] px-[15px] py-[6px] text-[10px] font-600 text-[#9F54B2]", "-mb-[10px] bg-gradient-to-r from-[#9f54b2]/30 to-[#9e77c5]/30"),
                                        children: t("txt_header_seo")
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("h2", {
                                        className: "w-[335px] text-center text-[24px] font-800 text-blue-900 tablet:w-full tablet:text-[40px] desktop:text-[48px]",
                                        children: t("txt_header_losung")
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("p", {
                                        className: (0,clsx__WEBPACK_IMPORTED_MODULE_20__/* ["default"] */ .Z)("max-w-[494px] text-center text-[16px] font-400 text-blue-700", "tablet:text-[22px] tablet:font-500"),
                                        children: t("txt_header_desk")
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                                className: "flex flex-col items-center gap-[26px] pt-[26px]",
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_comps_image__WEBPACK_IMPORTED_MODULE_5__/* .CustomThemedResource */ .aK, {
                                        source: "/home/best-for-platform",
                                        format: "svg",
                                        alt: "best for ai icon"
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                                        className: "flex items-center gap-[9.5px] tablet:gap-[13.5px]",
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                                                className: "rounded-[7px] bg-color-cell",
                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_comps_image__WEBPACK_IMPORTED_MODULE_5__/* .CustomThemedResource */ .aK, {
                                                    source: "/icons/home/cover/web-new",
                                                    format: "svg",
                                                    className: "h-[31px] tablet:h-[45px]"
                                                })
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                                                className: (0,clsx__WEBPACK_IMPORTED_MODULE_20__/* ["default"] */ .Z)("group relative flex items-center gap-[9.5px] tablet:gap-[13.5px]"),
                                                children: [
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                                                        className: "rounded-[7px] bg-color-cell hover:bg-color-separator desktop:hover:bg-color-cell",
                                                        onClick: function() {
                                                            if (window.innerWidth >= 768) {
                                                                return;
                                                            }
                                                            router.push(_utils_branch__WEBPACK_IMPORTED_MODULE_6__/* .appStoreConstant */ .HY);
                                                        },
                                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_comps_image__WEBPACK_IMPORTED_MODULE_5__/* .CustomThemedResource */ .aK, {
                                                            source: "/icons/home/cover/app-store",
                                                            format: "svg",
                                                            className: "h-[31px] tablet:h-[45px]"
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                                                        className: "rounded-[7px] bg-color-cell hover:bg-color-separator desktop:hover:bg-color-cell",
                                                        onClick: function() {
                                                            if (window.innerWidth >= 768) {
                                                                return;
                                                            }
                                                            router.push(_utils_branch__WEBPACK_IMPORTED_MODULE_6__/* .appStoreConstant */ .HY);
                                                        },
                                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_comps_image__WEBPACK_IMPORTED_MODULE_5__/* .CustomThemedResource */ .aK, {
                                                            source: "/icons/home/cover/google-play",
                                                            format: "svg",
                                                            className: "h-[31px] tablet:h-[45px]"
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                                                        className: (0,clsx__WEBPACK_IMPORTED_MODULE_20__/* ["default"] */ .Z)("absolute left-[80px] z-40 -translate-x-1/2 group-hover:opacity-100", "-translate-y-2 opacity-0 transition-all duration-500 group-hover:translate-y-4", "pointer-events-none top-full hidden group-hover:pointer-events-auto tablet:block desktop:block"),
                                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_qr__WEBPACK_IMPORTED_MODULE_17__/* ["default"] */ .Z, {})
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(GridColumns, {
                                setGalleryPopupState: setGalleryPopupState,
                                columns: columns,
                                shouldPlay: !Boolean(galleryPopupState)
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                className: "flex w-full justify-center px-[16px]",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_comps_button__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP, {
                    text: t("txt_discover_more"),
                    href: "/ai-gallery",
                    primary: true,
                    className: "w-full max-w-[495px] desktop:w-[243px]"
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_platforms_runner__WEBPACK_IMPORTED_MODULE_16__["default"], {}),
            galleryPopupState !== null && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(sections_gallery_gallery_popup__WEBPACK_IMPORTED_MODULE_15__/* .GalleryPopup */ .wY, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_21__/* ["default"] */ .Z)({}, galleryPopupState))
        ]
    });
}
function GridColumns(props) {
    var galleryPopupSeter = function galleryPopupSeter(id) {
        columns.filter(function(column) {
            column.filter(function(single) {
                if (single.type === "gallery" && single.data.id === id) {
                    var ref;
                    var data = single.data;
                    var _prompt, _prompt1;
                    setGalleryPopupState({
                        imageOrVideo: data.object_urls.map(function(image) {
                            return image.object;
                        }),
                        previewImage: data.object_urls[0].thumb,
                        id: id,
                        tool: "text_to_image",
                        createdAt: 1,
                        prompt: (_prompt = data.prompt) !== null && _prompt !== void 0 ? _prompt : "",
                        onClose: function() {
                            setGalleryPopupState(null);
                        },
                        showFor: false,
                        notShallow: true,
                        privacy: "private",
                        customPrompt: (_prompt1 = data.prompt) !== null && _prompt1 !== void 0 ? _prompt1 : "",
                        promptName: "",
                        handleRetry: function() {
                            return handleRetry(data.style, data.prompt);
                        },
                        closeLink: "/",
                        username: data.owner.username,
                        followers: data.owner.followers,
                        profile_pic: (ref = data.owner.profile_pic) === null || ref === void 0 ? void 0 : ref.original,
                        ownerId: data.owner.uid,
                        likes: single.data.likes,
                        views: single.data.views,
                        showRelated: true
                    });
                }
            });
        });
    };
    var setGalleryPopupState = props.setGalleryPopupState, columns = props.columns, shouldPlay = props.shouldPlay;
    var editor = (0,sections_editor_editor__WEBPACK_IMPORTED_MODULE_14__/* .useEditorParamsContext */ .mK)();
    var userInfo = (0,_utils_client_auth__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .ZP)().userInfo;
    function handleRetry(promptType, text) {
        return _handleRetry.apply(this, arguments);
    }
    function _handleRetry() {
        _handleRetry = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_22__/* ["default"] */ .Z)(function(promptType, text) {
            return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_23__.__generator)(this, function(_state) {
                if (userInfo.isAnonymous) {
                    return [
                        2
                    ];
                }
                editor.openPage({
                    tool: "text_to_image",
                    id: _comps_editors_text_to_image__WEBPACK_IMPORTED_MODULE_4__.DEFORUM_STORAGE_KEY,
                    promptType: promptType,
                    text: text !== null && text !== void 0 ? text : "",
                    location: "remote",
                    url: null
                });
                return [
                    2
                ];
            });
        });
        return _handleRetry.apply(this, arguments);
    }
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
        className: (0,clsx__WEBPACK_IMPORTED_MODULE_20__/* ["default"] */ .Z)("mt-[36px] h-[555px] overflow-hidden rounded-[18px]", "relative w-[341px] tablet:h-[460px] tablet:w-[728px] desktop:h-[630px] desktop:w-[1176px]", "border border-color-separator bg-color-cell"),
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                className: (0,clsx__WEBPACK_IMPORTED_MODULE_20__/* ["default"] */ .Z)("absolute grid grid-cols-2 gap-[17px] px-[16px] tablet:hidden"),
                children: columns.slice(0, 2).map(function(column, index) {
                    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(RenderColumn, {
                        column: column,
                        galleyPopupSeter: galleryPopupSeter,
                        shouldPlay: shouldPlay,
                        columnIndex: index + 1
                    }, index);
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                className: (0,clsx__WEBPACK_IMPORTED_MODULE_20__/* ["default"] */ .Z)("absolute hidden desktop:grid desktop:grid-cols-5 desktop:gap-[28px] desktop:px-[44px]"),
                children: columns.map(function(column, index) {
                    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(RenderColumn, {
                        column: column,
                        galleyPopupSeter: galleryPopupSeter,
                        shouldPlay: shouldPlay,
                        columnIndex: index + 1
                    }, index);
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                className: (0,clsx__WEBPACK_IMPORTED_MODULE_20__/* ["default"] */ .Z)("absolute hidden gap-[17px] px-[16px] tablet:grid tablet:grid-cols-4 desktop:hidden"),
                children: columns.slice(0, 4).map(function(column, index) {
                    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(RenderColumn, {
                        column: column,
                        galleyPopupSeter: galleryPopupSeter,
                        shouldPlay: shouldPlay,
                        columnIndex: index + 1
                    }, index);
                })
            })
        ]
    });
}
var createRunnerAnim = function(distance) {
    return (0,styled_components__WEBPACK_IMPORTED_MODULE_18__/* .keyframes */ .F4)(_templateObject1(), distance);
};
var COLUMN_LENGTH = 5;
var runnerAnim = createRunnerAnim(COLUMN_LENGTH * 224 + COLUMN_LENGTH * 12);
var runnerAnimTablet = createRunnerAnim(COLUMN_LENGTH * 238 + COLUMN_LENGTH * 12);
var runnerAnimDesktop = createRunnerAnim(COLUMN_LENGTH * 299 + COLUMN_LENGTH * 16);
var ColumnStyleDiv = styled_components__WEBPACK_IMPORTED_MODULE_18__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-6b3067e8-1"
})(_templateObject4(), _utils_breakpoints__WEBPACK_IMPORTED_MODULE_7__/* .devices.desktop */ .Hb.desktop, function(props) {
    return props.shouldPlay ? (0,styled_components__WEBPACK_IMPORTED_MODULE_18__/* .css */ .iv)(_templateObject2(), runnerAnim, 15 * (props.columnIndex * 3), _utils_breakpoints__WEBPACK_IMPORTED_MODULE_7__/* .devices.tablet */ .Hb.tablet, runnerAnimTablet, 30 + 15 * (props.columnIndex % 3), _utils_breakpoints__WEBPACK_IMPORTED_MODULE_7__/* .devices.desktop */ .Hb.desktop, runnerAnimDesktop, (30 + 5 * (props.columnIndex % 3)) * 1.5) : (0,styled_components__WEBPACK_IMPORTED_MODULE_18__/* .css */ .iv)(_templateObject3());
});
function RenderColumn(props) {
    var column = props.column, galleyPopupSeter = props.galleyPopupSeter, shouldPlay = props.shouldPlay, columnIndex = props.columnIndex;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(ColumnStyleDiv, {
        shouldPlay: shouldPlay,
        columnIndex: columnIndex,
        children: [
            column.map(function(single) {
                switch(single.type){
                    case "gallery":
                        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("button", {
                            className: (0,clsx__WEBPACK_IMPORTED_MODULE_20__/* ["default"] */ .Z)("flex rounded-[8px] transition-transform duration-300", "bg-color-skeleton hover:scale-105 hover:rounded-[4px]"),
                            onClick: function() {
                                return galleyPopupSeter(single.data.id);
                            },
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("img", {
                                src: single.data.object_urls[0].thumb,
                                className: (0,clsx__WEBPACK_IMPORTED_MODULE_20__/* ["default"] */ .Z)("h-[224px] w-[146px] tablet:h-[238px] tablet:w-[165px]", "desktop:h-[299px] desktop:w-[195px]", "rounded-[7px] object-cover"),
                                alt: "Image-".concat(single.data.id)
                            })
                        }, single.data.id);
                    case "template":
                        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_10___default()), {
                            href: "/template/".concat(single.data.id),
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("a", {
                                className: (0,clsx__WEBPACK_IMPORTED_MODULE_20__/* ["default"] */ .Z)("flex rounded-[8px] bg-color-skeleton transition-transform", "duration-300 hover:scale-105 hover:rounded-[4px]"),
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("video", {
                                    src: (0,_utils_cdn__WEBPACK_IMPORTED_MODULE_19__/* .assetUrl */ .p)("/template-videos/templates/".concat(single.data.id, ".mp4#t=0.001")),
                                    playsInline: true,
                                    poster: single.data.image,
                                    loop: true,
                                    autoPlay: shouldPlay,
                                    preload: "none",
                                    muted: true,
                                    className: (0,clsx__WEBPACK_IMPORTED_MODULE_20__/* ["default"] */ .Z)("h-[224px] w-[146px] tablet:h-[238px] tablet:w-[165px]", "desktop:h-[299px] desktop:w-[195px]", "rounded-[7px] object-cover")
                                })
                            })
                        }, "".concat(single.data.id, "-duplicate"));
                }
            }),
            column.map(function(single) {
                switch(single.type){
                    case "gallery":
                        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("button", {
                            className: (0,clsx__WEBPACK_IMPORTED_MODULE_20__/* ["default"] */ .Z)("flex rounded-[8px] transition-transform duration-300", "bg-color-skeleton hover:scale-105 hover:rounded-[4px]"),
                            onClick: function() {
                                return galleyPopupSeter(single.data.id);
                            },
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("img", {
                                src: single.data.object_urls[0].thumb,
                                className: (0,clsx__WEBPACK_IMPORTED_MODULE_20__/* ["default"] */ .Z)("h-[224px] w-[146px] tablet:h-[238px] tablet:w-[165px]", "desktop:h-[299px] desktop:w-[195px]", "rounded-[7px] object-cover"),
                                alt: "Image-".concat(single.data.id)
                            })
                        }, "".concat(single.data.id, "-duplicate"));
                    case "template":
                        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_10___default()), {
                            href: "/template/".concat(single.data.id),
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("a", {
                                className: (0,clsx__WEBPACK_IMPORTED_MODULE_20__/* ["default"] */ .Z)("flex rounded-[8px] transition-transform", "bg-color-skeleton duration-300 hover:scale-105 hover:rounded-[4px]"),
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("video", {
                                    src: (0,_utils_cdn__WEBPACK_IMPORTED_MODULE_19__/* .assetUrl */ .p)("/template-videos/templates/".concat(single.data.id, ".mp4#t=0.001")),
                                    playsInline: true,
                                    loop: true,
                                    poster: single.data.image,
                                    autoPlay: shouldPlay,
                                    preload: "none",
                                    muted: true,
                                    className: (0,clsx__WEBPACK_IMPORTED_MODULE_20__/* ["default"] */ .Z)("h-[224px] w-[146px] tablet:h-[238px] tablet:w-[165px]", "desktop:h-[299px] desktop:w-[195px]", "rounded-[7px] object-cover")
                                })
                            })
                        }, "".concat(single.data.id, "-duplicate"));
                }
            })
        ]
    });
}
var templateItemSchema = zod__WEBPACK_IMPORTED_MODULE_24__.z.object({
    id: zod__WEBPACK_IMPORTED_MODULE_24__.z.string(),
    name: zod__WEBPACK_IMPORTED_MODULE_24__.z.string(),
    description: zod__WEBPACK_IMPORTED_MODULE_24__.z.string(),
    video: zod__WEBPACK_IMPORTED_MODULE_24__.z.string(),
    image: zod__WEBPACK_IMPORTED_MODULE_24__.z.string()
});


/***/ }),

/***/ 5404:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(5893);
/* harmony import */ var _comps_image__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(9612);
/* harmony import */ var _comps_text__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(64);
/* harmony import */ var _utils_cdn__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(177);
/* harmony import */ var react_styled_flex__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(4382);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(9521);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  padding: 9px;\n  margin: 9px;\n  gap: 9px;\n\n  background-color: var(--color-000);\n  border-radius: 12px;\n  box-shadow: 0 0 30px rgba(0, 0, 0, 0.13);\n  text-align: center;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}






var qrCodeImage = (0,_utils_cdn__WEBPACK_IMPORTED_MODULE_5__/* .assetUrl */ .p)("/home/qrcode.webp");
var Container = styled_components__WEBPACK_IMPORTED_MODULE_6__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-fdc7e17e-0"
})(_templateObject());
var QR = function() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(Container, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_comps_image__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP, {
                src: qrCodeImage,
                width: 450,
                height: 450
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(react_styled_flex__WEBPACK_IMPORTED_MODULE_4__/* .FlexBox */ .hs, {
                width: "140px",
                marginBottom: 9,
                style: {
                    lineHeight: "16px"
                },
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_comps_text__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                    content: "txt_download_qr",
                    size: "14",
                    weight: "500",
                    color: "700"
                })
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (QR);


/***/ })

}]);